import { UserManager } from "oidc-client-ts";
import Cookies from 'js-cookie';
import { GrantTypes, OIDC_DATA_KEY, TOKEN_DATA_KEY, MEDIA_TOKEN_KEY, userSessionState } from "./AMTypes";
import { logoutAM, retrieveAmTokenData } from "./AMRequests";
export class AschehougOidcClient {
    constructor(config) {
        this.getFeideAuthUrl = () => `${this.config.authority}/am/XUI/?service=skoleFeide&realm=/&goto=${this.config.redirect_feide_uri}&gotoOnFail=${this.config.idCloudUrl}/feil#login`;
        this.getLocalStorage = (key) => JSON.parse(localStorage.getItem(key));
        this.getAmTokenData = () => {
            const cookie = Cookies.get(this.config.tokenCookieName);
            if (!cookie)
                return null;
            return JSON.parse(cookie);
        };
        this.getOidcData = () => this.getLocalStorage(localStorage.getItem(OIDC_DATA_KEY));
        this.getAccessToken = () => { var _a; return (_a = this.getAmTokenData()) === null || _a === void 0 ? void 0 : _a.access_token; };
        this.logout = async () => {
            logoutAM(this.config.external_api_url, this.config.redirect_uri);
            const cookieOptions = {
                domain: this.config.cookieDomain,
                path: '/'
            };
            Cookies.remove(this.config.tokenCookieName, cookieOptions);
            Cookies.remove(this.config.mediaTokenCookieName, cookieOptions);
        };
        this.authorize = async () => await this.tsOIDCManager.signinRedirect();
        this.onAuthRedirect = async (code) => {
            var _a;
            const oidcCodeVerifier = (_a = this.getOidcData()) === null || _a === void 0 ? void 0 : _a.code_verifier;
            try {
                const amTokenData = await retrieveAmTokenData(this.config.base_uri_am, {
                    grant_type: GrantTypes.authorizationCode,
                    code,
                    client_id: this.config.client_id,
                    redirect_uri: this.config.redirect_uri,
                    code_verifier: oidcCodeVerifier
                });
                this.setTokenCookies(amTokenData);
                return userSessionState.hasActiveSession;
            }
            catch (e) {
                console.warn("Failed fetching access_token", e);
                return userSessionState.noActiveSessionFound;
            }
        };
        this.getCookieExpireDate = (expirationInSeconds) => {
            const date = new Date();
            date.setTime(date.getTime() + expirationInSeconds * 1000);
            return date;
        };
        this.setTokenCookies = (amTokenData) => {
            const cookieOptions = {
                domain: this.config.cookieDomain,
                sameSite: 'none',
                path: '/',
                secure: true,
                expires: this.getCookieExpireDate(amTokenData.expires_in),
            };
            Cookies.set(this.config.tokenCookieName, JSON.stringify(amTokenData), cookieOptions);
            // backend services require the access_token to be in a cookie
            Cookies.set(this.config.mediaTokenCookieName, amTokenData.access_token, cookieOptions);
        };
        this.refreshAccessToken = async () => {
            var _a, _b;
            const refreshToken = (_a = this.getAmTokenData()) === null || _a === void 0 ? void 0 : _a.refresh_token;
            const oidcCodeVerifier = (_b = this.getOidcData()) === null || _b === void 0 ? void 0 : _b.code_verifier;
            if (!refreshToken)
                throw new Error('Tried to call refreshAccessToken without refresh_token');
            try {
                const amTokenData = await retrieveAmTokenData(this.config.base_uri_am, {
                    grant_type: GrantTypes.refreshToken,
                    refresh_token: refreshToken,
                    client_id: this.config.client_id,
                    redirect_uri: this.config.redirect_uri,
                    code_verifier: oidcCodeVerifier
                });
                this.setTokenCookies(amTokenData);
                return userSessionState.hasActiveSession;
            }
            catch (e) {
                console.warn("Failed refreshing access_token", e);
            }
        };
        this.startAuthSession = async () => {
            const params = new URLSearchParams(window.location.search);
            const state = params.get('state');
            const code = params.get('code');
            const accessToken = this.getAccessToken();
            if (state)
                localStorage.setItem(OIDC_DATA_KEY, 'oidc.' + state);
            // When user is redirected from https://id.*.aschehoug.cloud/ with state & code
            if (state && code)
                return await this.onAuthRedirect(code);
            // If logged in and page refreshes, set oidc localstorage key id so it can be grabbed for later use
            if (accessToken)
                return userSessionState.hasActiveSession;
            return userSessionState.noActiveSessionFound;
        };
        this.config = { tokenCookieName: TOKEN_DATA_KEY, mediaTokenCookieName: MEDIA_TOKEN_KEY, ...config };
        this.tsOIDCManager = new UserManager(this.config);
    }
}
//# sourceMappingURL=AschehougOidcClient.js.map